import { ReactNode } from 'react';

import {
  CARD_CODES,
  CARD_LOGIN_TYPE_BY_ORGANIZATION_CODE,
  CardCodes,
  CardLoginType,
} from '@revenuemarket/bank';
import { Alert, Typography } from 'antd';

interface Props {
  organizationCode: CardCodes;
  onChangeOrganizationCode: (organizationCode: CardCodes) => void;
}
const AlertConnectInfo = ({ organizationCode, onChangeOrganizationCode }: Props) => {
  const getAlertMessageForOrganization = (organizationCode: CardCodes): ReactNode[] | null => {
    const loginType =
      CARD_LOGIN_TYPE_BY_ORGANIZATION_CODE[
        organizationCode as keyof typeof CARD_LOGIN_TYPE_BY_ORGANIZATION_CODE
      ][0];
    const organizationName = CARD_CODES[organizationCode as keyof typeof CARD_CODES];
    if (loginType === CardLoginType.LOGIN_ID) {
      if (organizationName === '신한카드') {
        return ['반드시 총괄관리자 계정으로 로그인해주세요.'];
      }
      if (organizationName === '롯데카드') {
        return ['반드시 법인관리자 계정으로 로그인해주세요.'];
      }
      if (organizationName === 'BC카드') {
        return [
          <>
            우리BC카드는{' '}
            <Typography.Link
              onClick={() => {
                onChangeOrganizationCode('309');
              }}
            >
              우리카드로 로그인
            </Typography.Link>
            해주세요.
          </>,
          <>
            KB-BC카드는{' '}
            <Typography.Link
              onClick={() => {
                onChangeOrganizationCode('301');
              }}
            >
              KB카드로 로그인
            </Typography.Link>
            해주세요.
          </>,
        ];
      }
    }
    if (loginType === CardLoginType.CERTIFICATE) {
      return [`${organizationName} 법인 홈페이지에 로그인 가능한 공동인증서를 추가해주세요.`];
    }
    return null;
  };

  const message = getAlertMessageForOrganization(organizationCode);
  if (!message) {
    return null;
  }

  return (
    <>
      {Array.from(message).map((msg, index) => (
        <Alert showIcon banner style={{ gap: 8 }} type="info" message={msg} />
      ))}
    </>
  );
};

export default AlertConnectInfo;
